<template>
    <div class="language-switcher">
      <button 
        @click="switchLanguage('fr')" 
        :class="{ active: currentLocale === 'fr' }"
        aria-label="Français"
        title="Passer en français"
      >
        <span class="flag flag-fr">🇫🇷</span>
      </button>
      <button 
        @click="switchLanguage('en')" 
        :class="{ active: currentLocale === 'en' }"
        aria-label="English"
        title="Switch to English"
      >
        <span class="flag flag-en">🇺🇸</span>
      </button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LanguageSwitcher',
    computed: {
      currentLocale() {
        return this.$route.meta?.locale || 'fr';
      }
    },
    methods: {
      switchLanguage(locale) {
        if (locale === this.currentLocale) return;
        
        let targetPath;
        if (locale === 'en') {
          // Si on change pour l'anglais, ajouter "/en" au début
          targetPath = `/en${this.$route.path === '/' ? '' : this.$route.path}`;
        } else {
          // Si on change pour le français, enlever "/en" du début
          targetPath = this.$route.path.replace(/^\/en/, '');
          if (targetPath === '') targetPath = '/';
        }
        
        // Naviguer vers la nouvelle URL
        this.$router.push(targetPath);
      }
    }
  }
  </script>
  
  <style scoped>
  .language-switcher {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: rgba(240, 240, 240, 0.4);
    padding: 5px 8px;
    border-radius: 20px;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .language-switcher button {
    background: none;
    border: none;
    padding: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 50%;
    position: relative;
  }
  
  .language-switcher button:hover {
    transform: scale(1.15);
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .language-switcher button.active {
    background-color: white;
    box-shadow: 0 2px 4px rgba(99, 102, 241, 0.3);
  }
  
  .language-switcher button.active::after {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 50%;
    transform: translateX(-50%);
    width: 6px;
    height: 6px;
    background-color: #6366F1;
    border-radius: 50%;
  }
  
  .flag {
    font-size: 1.25rem; /* Agrandi */
    display: block;
  }
  
  /* Animation subtile pour attirer l'attention */
  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  }
  
  /* Appliquer l'animation seulement sur le chargement initial */
  .language-switcher:hover button:not(:hover) {
    animation: none;
  }
  
  .language-switcher button {
    animation: pulse 2s infinite;
  }
  
  .language-switcher:hover button {
    animation: none;
  }
  </style>